import React from 'react'
import { Alert } from '@mui/material'

/** Friendly in-page notice for the backend kill switch (503 "Push campaigns are not enabled"). */
const PushDisabledNotice: React.FC = () => (
    <Alert
        severity="warning"
        sx={{
            background: '#f59e0b10', border: '1px solid #f59e0b30', color: '#f59e0b',
            borderRadius: '10px', '& .MuiAlert-icon': { color: '#f59e0b' },
        }}
    >
        Push campaigns are currently turned off on the server. Ask an administrator to enable them
        (ENABLE_PUSH_CAMPAIGNS) and then reload this page.
    </Alert>
)

export const InlineAlert: React.FC<{ severity?: 'error' | 'info' | 'warning' | 'success'; children: React.ReactNode; onClose?: () => void; sx?: object }> = ({ severity = 'error', children, onClose, sx }) => {
    const color = { error: '#ef4444', info: '#3b82f6', warning: '#f59e0b', success: '#10b981' }[severity]
    return (
        <Alert
            severity={severity}
            onClose={onClose}
            sx={{
                background: `${color}10`, border: `1px solid ${color}30`, color,
                borderRadius: '10px', fontSize: 13,
                '& .MuiAlert-icon': { color }, '& .MuiAlert-action': { color },
                ...sx,
            }}
        >
            {children}
        </Alert>
    )
}

export default PushDisabledNotice
